import { useEffect, useState } from 'react';

export const useStickyFooterHeight = (selector = '.cms-sticky-footer'): number => {
    const [height, setHeight] = useState(0);

    useEffect(() => {
        const updateHeight = () => {
            const stickyFooter = document.querySelector(selector) as HTMLElement | null;
            if (stickyFooter) {
                const newHeight = stickyFooter.offsetHeight;
                setHeight(prev => prev !== newHeight ? newHeight : prev);
            }
        };

        const footer = document.querySelector('.cms-footer-section') as HTMLElement | null;
        const observer = new MutationObserver(updateHeight);

        if (footer) {
            observer.observe(footer, { childList: true, subtree: true });
        }

        updateHeight();

        return () => observer.disconnect();
    }, [selector]);

    return height;
};
